export default __webpack_public_path__ + "static/damixa-brand--mobile@1x-69cb21d4ca991a134de156e63cc02fbd.jpg";